module.exports = __webpack_public_path__ + "img/Quatsch.2649e41e.svg";